var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 54,
    viewBox: "0 0 51 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.94375L25.1303 0L50.922 8.80537L46.7539 42.039L25.1303 54L3.85763 42.1942L0 8.94375Z",
    fill: "#9E35EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9226 8.80537L25.1309 0V54L46.7545 42.039L50.9226 8.80537Z",
    fill: "#932A9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1688 6.3125L9.50879 41.1425L15.3526 41.0244L18.5082 33.1539H32.5145L35.9435 41.0851L41.5156 41.2033L25.1688 6.3125ZM25.2076 17.4939L30.5063 28.5588H20.5872L25.2228 17.4939H25.2076Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.24724585eca808ecc54b9b1b28635aa4.svg";
export { ForwardRef as ReactComponent };